<template>
	<div class="mobile-home-page">
		<div class="mobile-container">
			<!-- 左侧预览区域 -->
			<div class="mobile-preview">
				<div class="mobile-device">
					<div class="mobile-device-header">
						<div class="mobile-device-title">效果预览</div>
						<div class="mobile-device-status">
							<span class="mobile-time">14:30</span>
							<div class="mobile-signal">
								<i class="el-icon-signal"></i>
							</div>
						</div>
					</div>
					<div class="mobile-screen">
						<!-- 页面标题 -->
						<div class="mobile-page-header">
							<div class="mobile-page-title">安心保</div>
						</div>

						<!-- 轮播图模块 -->
						<div :class="moduleIndex == 0 ? 'mobile-module mobile-swiper mobile-module-active' : 'mobile-module mobile-swiper'" 
							@click="selectModule(0)">
							<el-carousel height="130px" indicator-position="outside" arrow="never">
								<el-carousel-item v-for="(item, index) in data[0]" :key="index">
									<el-image class="mobile-banner" :src="$img(item.image)" fit="cover"></el-image>
								</el-carousel-item>
							</el-carousel>
							<div class="mobile-tips">建议尺寸750×300px</div>
						</div>

						<!-- 分类导航模块 -->
						<div :class="moduleIndex == 1 ? 'mobile-module mobile-category mobile-module-active' : 'mobile-module mobile-category'" 
							@click="selectModule(1)">
							<div class="mobile-category-grid">
								<div class="mobile-category-item" v-for="(item,index) in data[1]" :key="index">
									<div class="mobile-category-icon">
										<el-image :src="$img(item.image)" fit="cover" />
									</div>
									<div class="mobile-category-text">{{ item.title || '分类' }}</div>
								</div>
							</div>
							<div class="mobile-tips">建议图标尺寸60×60px</div>
						</div>

						<!-- 富文本模块 -->
						<div :class="moduleIndex == 2 ? 'mobile-module mobile-content mobile-module-active' : 'mobile-module mobile-content'" 
							@click="selectModule(2)">
							<div class="mobile-content-preview" v-html="data[2][0].content || '<p>点击编辑富文本内容</p>'"></div>
							<div class="mobile-tips">支持富文本编辑</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧编辑区域 -->
			<div class="mobile-editor">
				<!-- 编辑器头部 -->
				<div class="editor-header">
					<div class="header-main">
						<div class="header-info">
							<h3 class="header-title">
								<i class="el-icon-edit"></i>
								{{ getModuleTitle() }}
							</h3>
							<div class="header-tips">
								<el-tag v-if="moduleIndex === 0" size="small" class="tip-tag">轮播图模块</el-tag>
								<el-tag v-if="moduleIndex === 1" type="success" size="small" class="tip-tag">分类导航</el-tag>
								<el-tag v-if="moduleIndex === 2" type="warning" size="small" class="tip-tag">内容编辑</el-tag>
							</div>
						</div>
						<el-button class="save-btn" type="primary" @click="save(data)" :loading="saving">
							<i class="el-icon-check"></i>
							保存修改
						</el-button>
					</div>
				</div>

				<!-- 编辑器内容 -->
				<div class="editor-content">
					<!-- 轮播图和分类编辑 -->
					<div class="module-list" v-if="moduleIndex != 2">
						<div class="module-item" v-for="(item, index) in data[moduleIndex]" :key="index">
							<div class="item-header">
								<div class="item-info">
									<span class="item-index">#{{ index + 1 }}</span>
									<span class="item-title">{{ item.title || '未设置标题' }}</span>
								</div>
								<div class="item-actions">
									<el-tooltip content="上移" placement="top">
										<el-button size="mini" icon="el-icon-top" circle
											@click="moveUp(moduleIndex,index)" :disabled="index === 0"></el-button>
									</el-tooltip>
									<el-tooltip content="下移" placement="top">
										<el-button size="mini" icon="el-icon-bottom" circle
											@click="moveDown(moduleIndex,index)"
											:disabled="index === data[moduleIndex].length - 1"></el-button>
									</el-tooltip>
									<el-tooltip content="删除" placement="top">
										<el-button size="mini" icon="el-icon-delete" type="danger" circle
											@click="delModule(moduleIndex,index)"></el-button>
									</el-tooltip>
								</div>
							</div>

							<div class="item-body">
								<div class="item-image">
									<div class="image-label">
										<i class="el-icon-picture"></i>
										{{ moduleIndex === 0 ? '轮播图' : '分类图标' }}
									</div>
									<page-images @change="change" v-model="item.image" :limit="1" />
								</div>
								<div class="item-form">
									<el-form label-width="80px" size="small">
										<el-form-item label="标题">
											<el-input v-model="item.title" @input="change" placeholder="请输入标题"
												clearable />
										</el-form-item>
										<el-form-item label="跳转链接">
											<el-input v-model="item.url" @input="change" placeholder="请输入跳转链接"
												clearable>
												<template slot="append">
													<el-button icon="el-icon-link" @click="testLink(item.url)"></el-button>
												</template>
											</el-input>
										</el-form-item>
									</el-form>
								</div>
							</div>
						</div>

						<!-- 空状态 -->
						<div class="empty-state" v-if="moduleIndex != 2 && data[moduleIndex] && data[moduleIndex].length === 0">
							<i class="el-icon-picture-outline"></i>
							<p>暂无{{ getModuleTitle() }}数据</p>
							<el-button type="primary" icon="el-icon-plus" @click="addModule">添加模块</el-button>
						</div>
					</div>

					<!-- 富文本编辑器 -->
					<div class="rich-editor" v-if="moduleIndex == 2">
						<page-editor :height="480" v-model="data[moduleIndex][0].content" />
					</div>
				</div>

				<!-- 编辑器底部 -->
				<div v-if="moduleIndex > -1 && moduleIndex != 2" class="editor-footer">
					<div class="footer-info">
						<span class="module-count">已添加 {{ data[moduleIndex] ? data[moduleIndex].length : 0 }} 个模块</span>
					</div>
					<el-button class="add-btn" type="primary" icon="el-icon-plus" @click="addModule">
						添加模块
					</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HomeMobile',
		data() {
			return {
				moduleIndex: 0,
				data: [
					[], // 轮播图
					[], // 分类导航
					[{ content: '' }] // 富文本内容
				],
				saving: false
			}
		},
		mounted() {
			this.getPageData();
		},
		methods: {
			getModuleTitle() {
				const titles = ['轮播图管理', '分类导航管理', '富文本内容'];
				return titles[this.moduleIndex] || '模块编辑';
			},
			async save(data) {
				this.saving = true;
				try {
					await this.$put('app-page-design/1', {
						content: JSON.stringify(data)
					});
					this.$message.success('保存成功');
				} catch (err) {
					this.$message.error(err || '保存失败');
				} finally {
					this.saving = false;
				}
			},
			moveUp(moduleIndex, index) {
				if (index === 0) return;
				[this.data[moduleIndex][index], this.data[moduleIndex][index - 1]] = [
					this.data[moduleIndex][index - 1],
					this.data[moduleIndex][index]
				];
				this.$forceUpdate();
			},
			moveDown(moduleIndex, index) {
				if (index === this.data[moduleIndex].length - 1) return;
				[this.data[moduleIndex][index], this.data[moduleIndex][index + 1]] = [
					this.data[moduleIndex][index + 1],
					this.data[moduleIndex][index]
				];
				this.$forceUpdate();
			},
			delModule(moduleIndex, index) {
				this.$confirm('确定要删除这个模块吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.data[moduleIndex].splice(index, 1);
					this.$forceUpdate();
					this.$message.success('删除成功');
				}).catch(() => {});
			},
			change() {
				this.$forceUpdate();
			},
			testLink(url) {
				if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
					window.open(url, '_blank');
				} else if (url) {
					this.$message.warning('请输入有效的链接地址（以 http:// 或 https:// 开头）');
				} else {
					this.$message.warning('请输入链接地址');
				}
			},
			addModule() {
				if (this.moduleIndex == -1) {
					this.$message.warning('请先选择模块');
					return;
				}
				if (!this.data[this.moduleIndex]) {
					this.data[this.moduleIndex] = [];
				}
				this.data[this.moduleIndex].push({
					image: '',
					title: '',
					url: '',
					content: '',
				});
				this.$forceUpdate();
				this.$message.success('添加模块成功');
			},
			selectModule(index) {
				this.moduleIndex = index;
				if (!this.data[this.moduleIndex]) {
					this.addModule();
				}
			},
			async getPageData() {
				try {
					const res = await this.$get('app-page-design/1');
					if (res.data && res.data.content) {
						this.data = this.validateDataStructure(res.data.content);
					}
				} catch (err) {
					console.warn('数据加载失败:', err);
					// 保持默认数据
				}
			},
			validateDataStructure(content) {
				const validated = [];
				for (let i = 0; i < 3; i++) {
					if (content && content[i] && Array.isArray(content[i]) && content[i].length > 0) {
						validated[i] = content[i];
					} else {
						// 确保富文本模块至少有一个空对象
						validated[i] = i === 2 ? [{ content: '' }] : [];
					}
				}
				return validated;
			},
		},
	}
</script>

<style lang="scss" scoped>
.mobile-home-page {
	width: 100%;
	height: 100%;
	background: #f5f7fa;
	padding: 20px;
	box-sizing: border-box;
	
	.mobile-container {
		width: 100%;
		height: 100%;
		display: flex;
		gap: 30px;
		max-width: 1400px;
		margin: 0 auto;
	}

	/* 预览区域样式 */
	.mobile-preview {
		flex: 0 0 380px;
		display: flex;
		justify-content: center;
		align-items: flex-start;

		.mobile-device {
			width: 100%;
			max-width: 350px;
			height: 660px;
			border-radius: 30px;
			border: 1px solid #e1e4e8;
			overflow: hidden;
			background: #fff;
			box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
			position: relative;

			.mobile-device-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px 20px;
				background: #5B8CFF;
				color: white;

				.mobile-device-title {
					font-weight: 600;
					font-size: 14px;
				}

				.mobile-device-status {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 12px;

					.mobile-signal {
						display: flex;
						align-items: center;
					}
				}
			}

			.mobile-screen {
				height: calc(100% - 44px);
				overflow-y: auto;
				background: #f8f9fa;
				padding: 0;

				.mobile-page-header {
					background: #5B8CFF;
					padding: 16px;
					text-align: center;

					.mobile-page-title {
						font-size: 18px;
						font-weight: 700;
						color: white;
						letter-spacing: 1px;
					}
				}

				.mobile-module {
					margin: 12px;
					padding: 16px;
					background: white;
					border-radius: 12px;
					border: 2px solid transparent;
					transition: all 0.3s ease;
					cursor: pointer;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

					&:hover {
						border-color: #5B8CFF;
					}

					&.mobile-module-active {
						border: 2px dashed #5B8CFF;
						box-shadow: 0 0 0 4px rgba(91, 140, 255, 0.1);
					}

					.mobile-tips {
						text-align: center;
						color: #909399;
						font-size: 12px;
						margin-top: 8px;
						font-weight: 500;
					}
				}

				.mobile-swiper {
					.mobile-banner {
						width: 100%;
						height: 130px;
						border-radius: 8px;
					}
				}

				.mobile-category {
					.mobile-category-grid {
						display: grid;
						grid-template-columns: repeat(4, 1fr);
						gap: 12px;

						.mobile-category-item {
							display: flex;
							flex-direction: column;
							align-items: center;
							padding: 12px 8px;
							border-radius: 8px;
							transition: all 0.3s ease;
							background: #f8f9fa;

							&:hover {
								background: #e8f4ff;
								transform: translateY(-2px);
							}

							.mobile-category-icon {
								width: 40px;
								height: 40px;
								border-radius: 8px;
								overflow: hidden;
								margin-bottom: 8px;

								::v-deep .el-image {
									width: 100%;
									height: 100%;
								}
							}

							.mobile-category-text {
								font-size: 11px;
								color: #303133;
								text-align: center;
								line-height: 1.3;
								font-weight: 500;
							}
						}
					}
				}

				.mobile-content {
					min-height: 200px;

					.mobile-content-preview {
						min-height: 120px;
						color: #606266;
						line-height: 1.6;

						p {
							margin: 0 0 8px 0;
						}
					}
				}
			}
		}
	}

	/* 编辑区域样式 */
	.mobile-editor {
		flex: 1;
		background: white;
		border-radius: 16px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		border: 1px solid #e8e8e8;

		.editor-header {
			padding: 20px 24px;
			background: #5B8CFF;
			color: white;

			.header-main {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				gap: 20px;

				.header-info {
					flex: 1;

					.header-title {
						margin: 0 0 12px 0;
						font-size: 18px;
						font-weight: 700;
						display: flex;
						align-items: center;
						gap: 8px;

						i {
							font-size: 20px;
						}
					}

					.header-tips {
						.tip-tag {
							background: rgba(255, 255, 255, 0.2);
							border: none;
							color: white;
							font-weight: 500;
							margin-right: 8px;
						}
					}
				}

				.save-btn {
					background: rgba(255, 255, 255, 0.2);
					border: 1px solid rgba(255, 255, 255, 0.3);
					color: white;
					padding: 10px 24px;
					font-weight: 600;
					border-radius: 8px;
					transition: all 0.3s ease;

					&:hover {
						background: rgba(255, 255, 255, 0.3);
						transform: translateY(-1px);
						box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
					}

					&:disabled {
						opacity: 0.6;
						cursor: not-allowed;
						transform: none;
					}
				}
			}
		}

		.editor-content {
			flex: 1;
			overflow-y: auto;
			padding: 0;

			.module-list {
				padding: 24px;

				.module-item {
					background: #fafafa;
					border-radius: 12px;
					padding: 20px;
					margin-bottom: 16px;
					border: 1px solid #e8e8e8;
					transition: all 0.3s ease;

					&:hover {
						box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
						border-color: #5B8CFF;
					}

					.item-header {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 16px;
						padding-bottom: 12px;
						border-bottom: 1px dashed #e8e8e8;

						.item-info {
							display: flex;
							align-items: center;
							gap: 12px;

							.item-index {
								background: #5B8CFF;
								color: white;
								padding: 4px 8px;
								border-radius: 6px;
								font-size: 12px;
								font-weight: 600;
							}

							.item-title {
								font-weight: 600;
								color: #303133;
								font-size: 14px;
							}
						}

						.item-actions {
							display: flex;
							gap: 8px;

							::v-deep .el-button {
								transition: all 0.3s ease;

								&:hover {
									transform: scale(1.1);
								}

								&:disabled {
									opacity: 0.5;
									cursor: not-allowed;
									
									&:hover {
										transform: none;
									}
								}
							}
						}
					}

					.item-body {
						display: flex;
						gap: 20px;

						.item-image {
							flex: 0 0 120px;

							.image-label {
								font-size: 12px;
								color: #606266;
								margin-bottom: 8px;
								text-align: center;
								font-weight: 600;
								display: flex;
								align-items: center;
								justify-content: center;
								gap: 4px;
							}
						}

						.item-form {
							flex: 1;

							::v-deep .el-form-item {
								margin-bottom: 16px;

								&:last-child {
									margin-bottom: 0;
								}

								.el-form-item__label {
									font-weight: 600;
									color: #303133;
								}

								.el-input__inner {
									border-radius: 6px;
									border: 1px solid #dcdfe6;
									transition: all 0.3s ease;

									&:focus {
										border-color: #5B8CFF;
										box-shadow: 0 0 0 2px rgba(91, 140, 255, 0.1);
									}
								}
							}
						}
					}
				}

				.empty-state {
					text-align: center;
					padding: 60px 20px;
					color: #909399;

					i {
						font-size: 48px;
						margin-bottom: 16px;
						color: #c0c4cc;
					}

					p {
						margin: 0 0 20px 0;
						font-size: 14px;
					}
				}
			}

			.rich-editor {
				padding: 24px;
				height: 100%;

				::v-deep .page-editor {
					border-radius: 8px;
					overflow: hidden;
					border: 1px solid #dcdfe6;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
				}
			}
		}

		.editor-footer {
			padding: 20px 24px;
			border-top: 1px solid #f0f0f0;
			background: #fafafa;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.footer-info {
				.module-count {
					font-size: 14px;
					color: #606266;
					background: white;
					padding: 6px 12px;
					border-radius: 6px;
					border: 1px solid #e8e8e8;
					font-weight: 500;
				}
			}

			.add-btn {
				padding: 10px 24px;
				border-radius: 8px;
				font-weight: 600;
				background: #5B8CFF;
				border-color: #5B8CFF;
				transition: all 0.3s ease;

				&:hover {
					background: #4a7df5;
					border-color: #4a7df5;
					transform: translateY(-1px);
					box-shadow: 0 4px 12px rgba(91, 140, 255, 0.3);
				}
			}
		}
	}
}

/* 响应式设计 */
@media (max-width: 1280px) {
	.mobile-home-page {
		padding: 16px;
		
		.mobile-container {
			flex-direction: column;
			gap: 20px;

			.mobile-preview {
				flex: none;
				width: 100%;
				max-width: 350px;
				margin: 0 auto;
			}

			.mobile-editor {
				width: 100%;
				height: auto;
				min-height: 500px;
			}
		}
	}
}

@media (max-width: 768px) {
	.mobile-home-page {
		padding: 12px;
		
		.mobile-container {
			gap: 16px;

			.mobile-preview {
				.mobile-device {
					max-width: 320px;
					height: 580px;
					border-radius: 24px;
				}
			}

			.mobile-editor {
				.editor-header {
					padding: 16px 20px;

					.header-main {
						flex-direction: column;
						gap: 12px;

						.save-btn {
							align-self: flex-end;
						}
					}
				}

				.editor-content {
					.module-list {
						padding: 16px;

						.module-item {
							.item-body {
								flex-direction: column;
								gap: 16px;

								.item-image {
									flex: none;
									display: flex;
									flex-direction: column;
									align-items: center;
								}
							}
						}
					}

					.rich-editor {
						padding: 16px;
					}
				}

				.editor-footer {
					padding: 16px 20px;
					flex-direction: column;
					gap: 12px;
					text-align: center;
				}
			}
		}
	}
}
</style>